import { combineReducers } from "redux";
import openCloseReducer from "./openClose";
import projectReducer from './projectReducer'
const rootReducer=combineReducers({
    openCloseReducer,
    projectReducer
})

export default rootReducer;